/* eslint-disable import/prefer-default-export */

import { GET_DISCUSSIONS_REQUEST, GET_DISCUSSIONS_SUCCESS, GET_DISCUSSIONS_FAIL, RESET_DISCUSSIONS } from '../constants';
import { buildQuery } from '../helpers';
export function getDiscussions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    page: 1,
    perPage: 50,
    sort: '-createDate',
    search: ''
  };
  var query = buildQuery(params);
  return {
    types: [GET_DISCUSSIONS_REQUEST, GET_DISCUSSIONS_SUCCESS, GET_DISCUSSIONS_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/discussions?".concat(query), {
        method: 'GET'
      });
    }
  };
}
export function reset() {
  return {
    type: RESET_DISCUSSIONS
  };
}